import React from "react"
import SVG from "../../images/effects/flower-effect.inline.svg"

export default function FlowerEffect({ className }) {
  return <SVG className={className} />
}
